// Geteilte Konstanten für den Hero-Bereich der Startseite — genutzt sowohl
// von der Anzeige (LandingPage.js) als auch vom Master-Panel-Editor
// (HeroLayoutEditor.jsx), damit beide nie auseinanderlaufen.

export const DEFAULT_HERO_ELEMENTS = {
  kicker: { visible: true },
  onboarding: { visible: false },
  heading: { visible: true, size: 'md' },
  description: { visible: true, size: 'md' },
  cta_primary: { visible: true },
  cta_secondary: { visible: true },
  // Kein Standardtext mehr: der Kasten erscheint nur, wenn im Master-Panel Titel/Text eingetragen sind.
  badge: { visible: false },
};

export const HERO_ELEMENT_LABELS = {
  kicker: 'Kicker ("CHROBE ONE WORLD")',
  onboarding: 'Onboarding-Box',
  heading: 'Überschrift',
  description: 'Beschreibung',
  cta_primary: 'Button: Primär',
  cta_secondary: 'Button: Sekundär',
  badge: 'Premium-Partner-Badge',
};

// Elemente, für die eine Textgrößen-Steuerung angeboten wird.
export const SIZABLE_HERO_ELEMENTS = ['heading', 'description'];

// Elemente, die sich per Drag frei positionieren lassen (im normalen
// Textfluss würde eine freie Position sonst z.B. den Onboarding-Link
// unbedienbar machen — daher auf die visuell abgeschlossenen Blöcke
// beschränkt).
export const FREE_POSITIONABLE_HERO_ELEMENTS = ['heading', 'description', 'cta_primary', 'cta_secondary', 'badge', 'onboarding', 'kicker'];

export const HERO_SIZE_OPTIONS = ['sm', 'md', 'lg', 'xl'];

export const HERO_SIZE_CLASS_MAP = {
  heading: {
    sm: 'text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.1]',
    md: 'text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.08]',
    lg: 'text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05]',
    xl: 'text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-[1]',
  },
  description: {
    sm: 'text-sm max-w-lg leading-relaxed',
    md: 'text-base sm:text-lg max-w-lg leading-relaxed',
    lg: 'text-lg sm:text-xl max-w-xl leading-relaxed',
    xl: 'text-xl sm:text-2xl max-w-2xl leading-relaxed',
  },
};

export const DEFAULT_HERO_BUTTONS_ORDER = 'primary_first';
export const DEFAULT_HERO_LAYOUT_ALIGN = 'left';

export const heroElement = (heroElements, key) => ({
  ...DEFAULT_HERO_ELEMENTS[key],
  ...(heroElements?.[key] || {}),
});

export const isHeroElementVisible = (heroElements, key) => heroElement(heroElements, key).visible !== false;

export const heroElementSize = (heroElements, key) => heroElement(heroElements, key).size || DEFAULT_HERO_ELEMENTS[key]?.size || 'md';

export const heroFreePosition = (freePositions, key) => freePositions?.[key] || null;
